import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { NoteGroupPatch } from 'ri-api-client';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';

export interface IBillingMeasurementNote {
  'ucId': string;
  'companyId': number;
  'dateReference': string;
  'measurementNoteId': number;
  'commentNote': string;
  'measurementNote': {
    'name': string,
    'noteGroup': {
      'id': string,
      'name': string
    }
  }
}

@Injectable()
export class BillingMeasurementNoteService {

  private options: any;

  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: headers });
    this.apiService.init();
  }

  getBillingMeasurementNote(id, fields?: string): Observable<IBillingMeasurementNote> {
    return this.apiService.client.billingMeasurementNotes.GET(id, fields, this.options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getUcBillingMeasurementNotes(ucId, fields?: string, filter?: string): Observable<IBillingMeasurementNote[]> {
    return this.apiService.client.billingMeasurementNotes.uc.ucId(ucId).GET(fields, filter, this.options)
      .map((res) => {
        return this.apiService.handleResponse(res).results;
      });
  }

  getNoteGroups(onlyWithConfiguredMarkers = false): Observable<any> {
    return this.apiService.client.billingMeasurementNotes.noteGroups.GET(onlyWithConfiguredMarkers)
        .map((res) => this.apiService.handleResponse(res))
  }

  updateNoteGroups(noteGroupsId: string, body: NoteGroupPatch.NoteGroupPatch): Observable<any> {
    return this.apiService.client.billingMeasurementNotes.noteGroups.PATCH(encodeURIComponent(noteGroupsId), body)
      .map((res) => this.apiService.handleResponse(res));
  }

  getMeasurementNotesByNoteGroupsId(noteGroupsId: string): Observable<any> {
    return this.apiService.client.billingMeasurementNotes.noteGroups.measurementnotes.GET(encodeURIComponent(noteGroupsId))
      .map((res) => this.apiService.handleResponse(res));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/billing-measurement-note.service.ts